import './App.css';
import Forside from './pages/forside';

function App() {
  return (
    <div className="App">
      <Forside />
    </div>
  );
}

export default App;
